<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="mrfhr">
  <header class="mrfhr__page-head">
    <div class="mrfhr__title-row">
      <h1 class="mrfhr__title">Manpower Requisition Form</h1>
      <div class="mrf-header-statuses">
        <div class="mrf-header-status" *ngIf="requestStatusLabel">
          <span class="mrf-header-status__lbl">MRF Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="requestStatusTone">{{ requestStatusLabel }}</span>
        </div>
        <div class="mrf-header-status" *ngIf="onboardingStatusLabel">
          <span class="mrf-header-status__lbl">Onboarding Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="onboardingStatusTone">{{ onboardingStatusLabel }}</span>
        </div>
      </div>
    </div>
  </header>

  <!-- Read-only summary (sections 1–6) -->
  <div class="mrfhr__summary-panel">
    <!-- 1 Basic Information -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--blue">
      <span class="mrfhr__step mrfhr__step--blue" aria-hidden="true">1</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--blue">Basic Information</h2>
      <div class="mrfhr__row mrfhr__row--5">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Campus Name</span>
          <span class="mrfhr__ro-val">{{ mrfData?.campusName || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Employee Type</span>
          <span class="mrfhr__ro-val">{{ mrfData?.empType || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Teaching Type</span>
          <span class="mrfhr__ro-val">{{ mrfData?.roleType || mrfData?.TeachType || mrfData?.teachingType || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Department</span>
          <span class="mrfhr__ro-val">{{ mrfData?.departmentName || mrfData?.deptName || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Designation</span>
          <span class="mrfhr__ro-val">{{ mrfData?.desigName || mrfData?.designation || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="mrfData?.subName || mrfData?.subjectName">
          <span class="mrfhr__ro-lbl">Subject</span>
          <span class="mrfhr__ro-val">{{ mrfData?.subName || mrfData?.subjectName || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="mrfData?.workLoad && !isNonTeach">
          <span class="mrfhr__ro-lbl">WorkLoad per day</span>
          <span class="mrfhr__ro-val">{{ mrfData?.workLoad }}</span>
        </div>
      </div>
    </section>

    <!-- 2 Position Type -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--purple">
      <span class="mrfhr__step mrfhr__step--purple" aria-hidden="true">2</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--purple">Position Type</h2>
      <div class="mrfhr__row mrfhr__row--5">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Position Type</span>
          <span class="mrfhr__ro-val">{{ mrfData?.positionType || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="mrfData?.hiringReason">
          <span class="mrfhr__ro-lbl">Reason for Hiring</span>
          <span class="mrfhr__ro-val">{{ mrfData?.hiringReason }}</span>
        </div>
      </div>
      <div class="mrfhr__row mrfhr__row--5" *ngIf="isNewPosition">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Designation</span>
          <span class="mrfhr__ro-val">{{ displayField('newPositionDesigName', 'positionDesignation', 'posDesigName', 'desigName', 'designation') || '—' }}</span>
        </div>
      </div>
      <div class="mrfhr__row mrfhr__row--5" *ngIf="isReplacement">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Payroll Id</span>
          <span class="mrfhr__ro-val">{{ mrfData?.replacementEmpId || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Name</span>
          <span class="mrfhr__ro-val">{{ mrfData?.replacementEmpName || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Designation</span>
          <span class="mrfhr__ro-val">{{ mrfData?.replacementDesigName || mrfData?.replacementDesignation || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="isReasonExit">
          <span class="mrfhr__ro-lbl">Last Working Date</span>
          <span class="mrfhr__ro-val">{{ displayLastWorkingDate() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Current CTC</span>
          <span class="mrfhr__ro-val">{{ displayAmountField('currentCTC', 'ctc', 'currentSalary', 'prevRepEmpCtc') }}</span>
        </div>
      </div>
    </section>

    <!-- 3 Headcount Information -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--green">
      <span class="mrfhr__step mrfhr__step--green" aria-hidden="true">3</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--green">Headcount Information</h2>
      <div class="mrfhr__headcount-row">
        <div class="mrfhr__headcount-fields">
          <div class="mrfhr__row mrfhr__row--2">
            <div class="mrfhr__ro-fld">
              <span class="mrfhr__ro-lbl">No. of Budgeted Positions</span>
              <span class="mrfhr__ro-val">{{ budgetedPositions }}</span>
            </div>
            <div class="mrfhr__ro-fld">
              <span class="mrfhr__ro-lbl">No. of Headcount</span>
              <span class="mrfhr__ro-val">{{ noOfHeadcount }}</span>
            </div>
          </div>
        </div>
        <div class="mrfhr__headcount-aside">
          <span class="mrfhr__headcount-aside-lbl">Available Headcount (Budgeted - Actual) - {{ availableHeadcount }}</span>
        </div>
      </div>
    </section>

    <!-- 4 Qualification & Skills -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--orange">
      <span class="mrfhr__step mrfhr__step--orange" aria-hidden="true">4</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--orange">Qualification &amp; Skills</h2>
      <div class="mrfhr__row mrfhr__row--4">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Educational Qualification</span>
          <span class="mrfhr__ro-val">{{ mrfData?.qualificationName || mrfData?.qualification || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Educational Qualification (Additional)</span>
          <span class="mrfhr__ro-val">{{ mrfData?.additionalQualification || '—' }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Years of Experience</span>
          <span class="mrfhr__ro-val">{{ displayYearsOfExperience() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Skills</span>
          <span class="mrfhr__ro-val">{{ mrfData?.skills || '—' }}</span>
        </div>
      </div>
    </section>

    <!-- 5 Reporting Structure -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--teal">
      <span class="mrfhr__step mrfhr__step--teal" aria-hidden="true">5</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--teal">Reporting Structure</h2>
      <div class="mrfhr__row mrfhr__row--3">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Reporting Manager (Principal / Dean / AGM)</span>
          <span class="mrfhr__ro-val">{{ displayReportingManager() }}</span>
        </div>
      </div>
    </section>

    <!-- 6 Qualified Employee Details -->
    <section class="mrfhr__sum-sec mrfhr__sum-sec--blue mrfhr__sum-sec--last">
      <span class="mrfhr__step mrfhr__step--blue" aria-hidden="true">6</span>
      <h2 class="mrfhr__sec-title mrfhr__sec-title--blue">Qualified Employee Details</h2>
      <div class="mrfhr__row mrfhr__row--2 mrfhr__row--new-emp-head">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Exam Taken</span>
          <div class="mrfhr__exam-radio-row" role="group" aria-label="Exam taken">
            <span class="mrfhr__exam-radio" [class.mrfhr__exam-radio--on]="isExamTaken('yes')">
              <span class="mrfhr__exam-radio-dot" aria-hidden="true"></span>
              Yes
            </span>
            <span class="mrfhr__exam-radio" [class.mrfhr__exam-radio--on]="isExamTaken('no')">
              <span class="mrfhr__exam-radio-dot" aria-hidden="true"></span>
              No
            </span>
          </div>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="isExamTaken('yes')">
          <span class="mrfhr__ro-lbl">Employee Temp Id</span>
          <span class="mrfhr__ro-val">{{ displayTempPayrollId() }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="isExamTaken('no') && hasTempPayrollId()">
          <span class="mrfhr__ro-lbl">Temp Payroll Id</span>
          <span class="mrfhr__ro-val">{{ displayTempPayrollId() }}</span>
        </div>
      </div>
      <!-- <div class="mrfhr__row mrfhr__row--3" *ngIf="isRehiring && isExamTaken('no')">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Rehiring Employee Name</span>
          <span class="mrfhr__ro-val">{{ displayRehiringEmployeeName() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Designation</span>
          <span class="mrfhr__ro-val">{{ displayField('prevEmpDesignation', 'prevEmpDesignation') }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Mobile No.</span>
          <span class="mrfhr__ro-val">{{ displayField('mobileNo', 'mobileNumber', 'phoneNo') }}</span>
        </div>
      </div> -->
      <div class="mrfhr__row mrfhr__row--5 mrfhr__row--new-emp-top">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Name</span>
          <span class="mrfhr__ro-val">{{ displayEmployeeName() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Surname</span>
          <span class="mrfhr__ro-val">{{ displaySurname() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Mobile No.</span>
          <span class="mrfhr__ro-val">{{ displayField('mobileNo', 'mobileNumber', 'candidateMobile', 'mobile', 'phoneNo') }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Aadhaar Card No.</span>
          <span class="mrfhr__ro-val">{{ displayField('newEmpAadhar', 'aadharCardNo', 'candidateAadhar', 'aadharNo', 'aadhaarNo') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: aadhaarDocuments }"></ng-container>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Pan Card No.</span>
          <span class="mrfhr__ro-val">{{ displayField('panNo', 'panCardNo', 'candidatePan', 'panNumber', 'panCardNumber') }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: panDocuments }"></ng-container>
        </div>
      </div>
      <div
        class="mrfhr__row mrfhr__row--new-emp-bottom"
        [class.mrfhr__row--3]="!isReplacement"
        [class.mrfhr__row--4]="isReplacement"
      >
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">DOB</span>
          <span class="mrfhr__ro-val">{{ displayDob() }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Expected Salary</span>
          <span
            class="mrfhr__ro-val"
            [class.mrfhr__ro-val--budget-error]="isReplacementSalaryOverPercentageLimit"
          >{{ displayAmountField('expectedSalary', 'salaryBudget', 'expectedCTC', 'salary') }}</span>
        </div>
        <div class="mrfhr__ro-fld" *ngIf="isReplacement">
          <span class="mrfhr__ro-lbl">Hike Percentage</span>
          <span class="mrfhr__ro-val">{{ prevRepEmpCtcPlusPercentageLabel }}</span>
        </div>
        <div class="mrfhr__ro-fld mrfhr__new-emp-upload" *ngIf="isExamTaken('yes')">
          <span class="mrfhr__ro-lbl">Upload Exam Copy</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: examDocuments }"></ng-container>
        </div>
      </div>

      <ng-container *ngIf="isRehiring">
        <div class="mrfhr__chk mrfhr__chk--readonly" aria-label="Rehiring">
          <span class="mrfhr__chk-ui" [class.mrfhr__chk-ui--on]="isRehiring" aria-hidden="true"></span>
          <span class="mrfhr__chk-txt">Rehiring</span>
        </div>
        <div class="mrfhr__row mrfhr__row--3" *ngIf="rehiringPayrollIdDisplay">
          <div class="mrfhr__ro-fld">
            <span class="mrfhr__ro-lbl">Previous Payroll Id</span>
            <span class="mrfhr__ro-val">{{ rehiringPayrollIdDisplay }}</span>
          </div>
          <div class="mrfhr__ro-fld">
            <span class="mrfhr__ro-lbl">Date of Birth</span>
            <span class="mrfhr__ro-val">{{ displayRehiringDob() }}</span>
          </div>
          <div class="mrfhr__ro-fld" *ngIf="displayRehiringAadharNo() !== '—'">
            <span class="mrfhr__ro-lbl">Aadhaar No.</span>
            <span class="mrfhr__ro-val">{{ displayRehiringAadharNo() }}</span>
          </div>
        </div>
        <div class="mrfhr__row mrfhr__row--3" *ngIf="rehiringPayrollIdDisplay">
          <div class="mrfhr__ro-fld">
            <span class="mrfhr__ro-lbl">Name</span>
            <span class="mrfhr__ro-val">{{ displayRehiringEmployeeName() }}</span>
          </div>
          <div class="mrfhr__ro-fld">
            <span class="mrfhr__ro-lbl">Designation</span>
            <span class="mrfhr__ro-val">{{ displayField('prevEmpDesignation') }}</span>
          </div>
          <div class="mrfhr__ro-fld">
            <span class="mrfhr__ro-lbl">Mobile No.</span>
            <span class="mrfhr__ro-val">{{ displayField('mobileNo', 'mobileNumber', 'phoneNo') }}</span>
          </div>
        </div>
      </ng-container>

      <div class="mrfhr__row mrfhr__row--1" *ngIf="attachedDocuments.length">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Attached Files</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: attachedDocuments }"></ng-container>
        </div>
      </div>
    </section>
  </div>

  <h2 class="mrfhr__dept-title">HR Department</h2>

  <div class="mrfhr__panel">
    <!-- 7 Approved By Campus Level -->
    <section class="mrfhr__sec mrfhr__sec--blue" aria-labelledby="mrfhr-s7">
      <span class="mrfhr__step mrfhr__step--blue" aria-hidden="true">7</span>
      <h2 id="mrfhr-s7" class="mrfhr__sec-title mrfhr__sec-title--blue">Approved By Campus Level</h2>
      <div class="mrfhr__row mrfhr__row--3">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Approved By</span>
          <span class="mrfhr__ro-val">{{ displayField('campusLevelApprovedByName', 'approvedByCampusName', 'campusApprovedByName', 'principalDeanName') }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Employee Id</span>
          <span class="mrfhr__ro-val">{{ displayField('campusLevelApproverId', 'approvedByCampusEmpId', 'campusApprovedByEmpId', 'principalEmpId') }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Designation</span>
          <span class="mrfhr__ro-val">{{ displayField('campusLevelApproverDesig', 'approvedByCampusDesig', 'campusApprovedByDesig', 'principalDesigName') }}</span>
        </div>
      </div>
    </section>

    <!-- 8 Policy & Budget Checks -->
    <section class="mrfhr__sec mrfhr__sec--purple" aria-labelledby="mrfhr-s8">
      <span class="mrfhr__step mrfhr__step--purple" aria-hidden="true">8</span>
      <h2 id="mrfhr-s8" class="mrfhr__sec-title mrfhr__sec-title--purple">Policy &amp; Budget Checks</h2>

      <div class="mrfhr__row mrfhr__row--3">
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Is This Position Within The Rehire Policy Guidelines?</span>
          <span class="mrfhr__ro-val">{{ displayYesNo(rehirePolicyGuidelines) }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Is This Position Within The Rehire Cost?</span>
          <span class="mrfhr__ro-val">{{ displayYesNo(withinRehireCost) }}</span>
        </div>
        <div class="mrfhr__ro-fld">
          <span class="mrfhr__ro-lbl">Is This A Budgeted Position?</span>
          <span class="mrfhr__ro-val">{{ displayYesNo(isBudgetedPosition) }}</span>
        </div>
      </div>
    </section>

    <!-- 9 Job Description & Justification -->
    <section class="mrfhr__sec mrfhr__sec--red" aria-labelledby="mrfhr-s9">
      <span class="mrfhr__step mrfhr__step--red" aria-hidden="true">9</span>
      <h2 id="mrfhr-s9" class="mrfhr__sec-title mrfhr__sec-title--red">Job Description &amp; Justification</h2>

      <div class="mrfhr__ro-fld mrfhr__fld--mb">
        <span class="mrfhr__ro-lbl">Has The Job Description Been Attached?</span>
        <span class="mrfhr__ro-val">{{ displayYesNo(jobDescriptionAttached) }}</span>
      </div>

      <div class="mrfhr__ro-fld mrfhr__fld--full mrfhr__fld--mb">
        <span class="mrfhr__ro-lbl">Justification (For Position &amp; Salary)</span>
        <span class="mrfhr__ro-val mrfhr__ro-val--block">{{ justificationText || '—' }}</span>
      </div>

      <div class="mrfhr__fld mrfhr__fld--full mrfhr__fld--mb">
        <label class="mrfhr__lbl" *ngIf="showHrEditMode">Work Description | Responsibilities (Attach Job Description)</label>
        <span class="mrfhr__ro-lbl" *ngIf="!showHrEditMode">Work Description | Responsibilities (Attach Job Description)</span>
        <div class="mrfhr__ta-wrap" *ngIf="showHrEditMode">
          <textarea
            class="mrfhr__ta"
            rows="4"
            placeholder="Enter work description / responsibilities"
            [formControl]="workDescription"
            [maxLength]="workDescriptionMaxLength"
          ></textarea>
          <span class="mrfhr__char-count">{{ workDescriptionCount }}/{{ workDescriptionMaxLength }} chars</span>
        </div>
        <span class="mrfhr__ro-val mrfhr__ro-val--block" *ngIf="!showHrEditMode">{{ workDescriptionText || '—' }}</span>
      </div>

      <div class="mrfhr__doc-saved-block" *ngIf="jobDescDocuments.length">
        <span class="mrfhr__ro-lbl">Job Description Files</span>
        <ng-container *ngTemplateOutlet="fileChips; context: { docs: jobDescDocuments }"></ng-container>
      </div>

      <div class="mrfhr__attach-block" *ngIf="canEditWorkDescAndApprovalDocs">
        <label class="mrfhr__attach" [class.mrfhr__attach--disabled]="!canAddMoreFiles('job')"
          (click)="onAttachClick($event, 'job', jobDescFileInput)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
          </svg>
          <span class="mrfhr__attach-txt">Attach files (Job Description)</span>
          <span class="mrfhr__doc-hint"> — up to {{ maxPendingFiles }} files</span>
        </label>
        <input #jobDescFileInput type="file" hidden multiple (change)="onFilesSelected($event, 'job')" />
        <ul class="mrfhr__doc-pending" *ngIf="jobDescPendingFiles.length">
          <li *ngFor="let file of jobDescPendingFiles; let i = index" class="mrfhr__doc-pending-item">
            <span class="mrfhr__doc-pending-name" [title]="file.name">{{ file.name }}</span>
            <button type="button" class="mrfhr__doc-remove" (click)="removePendingFile('job', i)" aria-label="Remove file">×</button>
          </li>
        </ul>
        <p class="mrfhr__doc-meta" *ngIf="jobDescPendingFiles.length">
          {{ jobDescPendingFiles.length }}/{{ maxPendingFiles }} selected — uploads on submit
        </p>
        <span class="mrfhr__upload-error" *ngIf="getUploadFileError('job')">{{ getUploadFileError('job') }}</span>
      </div>

      <div class="mrfhr__fld mrfhr__fld--mb">
        <label class="mrfhr__lbl" *ngIf="showHrEditMode">Approved by</label>
        <span class="mrfhr__ro-lbl" *ngIf="!showHrEditMode">Approved by</span>
        <mat-select
          *ngIf="showHrEditMode"
          class="mrfhr__mat-select"
          placeholder="Select"
          [formControl]="approvedBy2"
          (selectionChange)="onApprovedBySelectionChange($event.value)"
        >
          <input
            matInput
            [matAutocomplete]="approvedByAuto"
            [formControl]="approvedBy"
            class="mrfhr__mat-select-input"
            placeholder="Enter name to select"
          />
          <mat-autocomplete autoActiveFirstOption #approvedByAuto="matAutocomplete"></mat-autocomplete>
          <mat-option *ngFor="let item of approvedByOptions | async" [value]="item?.name">
            {{ getApprovedByOptionLabel(item) }}
          </mat-option>
        </mat-select>
        <span class="mrfhr__ro-val" *ngIf="!showHrEditMode">{{ getManagementApprovedByDisplayLabel() }}</span>
      </div>

      <div class="mrfhr__doc-saved-block" *ngIf="approvalDocuments.length">
        <span class="mrfhr__ro-lbl">Approval Files</span>
        <ng-container *ngTemplateOutlet="fileChips; context: { docs: approvalDocuments }"></ng-container>
      </div>

      <div class="mrfhr__attach-block" *ngIf="canEditWorkDescAndApprovalDocs">
        <label class="mrfhr__attach" [class.mrfhr__attach--disabled]="!canAddMoreFiles('approval')"
          (click)="onAttachClick($event, 'approval', approvalFileInput)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
          </svg>
          <span class="mrfhr__attach-txt">Attach files (Approval)</span>
          <span class="mrfhr__doc-hint"> — up to {{ maxPendingFiles }} files</span>
        </label>
        <input #approvalFileInput type="file" hidden multiple (change)="onFilesSelected($event, 'approval')" />
        <ul class="mrfhr__doc-pending" *ngIf="approvedByPendingFiles.length">
          <li *ngFor="let file of approvedByPendingFiles; let i = index" class="mrfhr__doc-pending-item">
            <span class="mrfhr__doc-pending-name" [title]="file.name">{{ file.name }}</span>
            <button type="button" class="mrfhr__doc-remove" (click)="removePendingFile('approval', i)" aria-label="Remove file">×</button>
          </li>
        </ul>
        <p class="mrfhr__doc-meta" *ngIf="approvedByPendingFiles.length">
          {{ approvedByPendingFiles.length }}/{{ maxPendingFiles }} selected — uploads on submit
        </p>
        <span class="mrfhr__upload-error" *ngIf="getUploadFileError('approval')">{{ getUploadFileError('approval') }}</span>
      </div>
    </section>

    <!-- 10 Important Guidelines -->
    <section class="mrfhr__sec mrfhr__sec--gold mrfhr__sec--last" aria-labelledby="mrfhr-s10">
      <span class="mrfhr__step mrfhr__step--gold" aria-hidden="true">10</span>
      <h2 id="mrfhr-s10" class="mrfhr__sec-title mrfhr__sec-title--gold">Important Guidelines</h2>
      <div class="mrfhr__guide-box">
        <ul class="mrfhr__guide">
          <li>
            Any position that is substituted should have a replacement salary that is less than 18% of the current salary.
          </li>
          <li>
            If the new campus is inaugurated under any class, whether it is a replacement or a new branch offering the same programs, the average salary will be applicable
            according to the remaining academic months till the new year.
          </li>
          <li>
            If a new branch offers different programs, align to the approved salary structure for that program category.
          </li>
        </ul>
      </div>
    </section>

    <footer class="mrfhr__footer" *ngIf="showHrActions">
      <button type="button" class="mrfhr__btn mrfhr__btn--cancel" (click)="cancel()" [disabled]="isSaving">Cancel</button>
      <button type="button" class="mrfhr__btn mrfhr__btn--reject" (click)="submitHrReview('REJECTED')" [disabled]="isSaving">
        Reject
      </button>
      <button type="button" class="mrfhr__btn mrfhr__btn--approve" (click)="submitHrReview('APPROVED')" [disabled]="isSaving">
        {{ isSaving ? 'Submitting...' : 'Approve' }}
      </button>
    </footer>
  </div>
</div>

<ng-template #fileChips let-docs="docs">
  <div class="mrfhr__file-chips" *ngIf="docs?.length">
    <ng-container *ngFor="let doc of docs">
      <button
        type="button"
        *ngIf="canDownloadDocument(doc); else fileChipStatic"
        class="mrfhr__file-chip"
        (click)="onDocumentDownload(doc)"
        [title]="getDocumentName(doc)"
      >
        <span
          class="mrfhr__file-chip-ico"
          [class.mrfhr__file-chip-ico--pdf]="isPdfFile(doc)"
          [class.mrfhr__file-chip-ico--video]="isVideoFile(doc)"
          [class.mrfhr__file-chip-ico--img]="isImageFile(doc)"
        >{{ getDocumentIconLabel(doc) }}</span>
        <span class="mrfhr__file-chip-name">{{ getDocumentName(doc) }}</span>
      </button>
      <ng-template #fileChipStatic>
        <span class="mrfhr__file-chip mrfhr__file-chip--static" [title]="getDocumentName(doc)">
          <span
            class="mrfhr__file-chip-ico"
            [class.mrfhr__file-chip-ico--pdf]="isPdfFile(doc)"
            [class.mrfhr__file-chip-ico--video]="isVideoFile(doc)"
            [class.mrfhr__file-chip-ico--img]="isImageFile(doc)"
          >{{ getDocumentIconLabel(doc) }}</span>
          <span class="mrfhr__file-chip-name">{{ getDocumentName(doc) }}</span>
        </span>
      </ng-template>
    </ng-container>
  </div>
</ng-template>
